module.exports = __webpack_public_path__ + "img/th.76046533.png";